const IndeterminateProgressBar = () => {
  return (
    <div className="relative h-3 w-full overflow-hidden rounded-md bg-blue-300">
      <div className="indeterminate-progress absolute left-0 top-0 h-full bg-blue-500"></div>
    </div>
  );
};

export default IndeterminateProgressBar;
